import React from 'react'

import BackgroundCotacao from '../../../assets/img/backgrounds/bg-solicitar-cotacao.webp'
import BackgroundStatusCotacao from '../../../assets/img/backgrounds/bg-status-cotacao.webp'

const LeaseBail = React.lazy(() => import('./quotations/lease-bail/Quotation'))
const GuaranteeBID = React.lazy(() => import('./quotations/guarantee-bid/Quotation'))
const EngineeringRisk = React.lazy(() => import('./quotations/engineering-risk/Quotation'))
const GuaranteePerformance = React.lazy(() => import('./quotations/guarantee-performance/Quotation'))
const JudicialGuaranteeCivel = React.lazy(() => import('./quotations/judicial-guarantee-civel/Quotation'))
const JudicialGuaranteeAppeal = React.lazy(() => import('./quotations/judicial-guarantee-appeal/Quotation'))
const JudicialGuaranteeLabor = React.lazy(() => import('./quotations/judicial-guarantee-labor/Quotation'))
const OtherGuarantee = React.lazy(() => import('./quotations/guarantee-other/Quotation'))
const UploadAndExtractFile = React.lazy(() => import('../UploadAndExtractFile'))
const ProcessingContract = React.lazy(() => import('../ProcessingContract'))
const QuotationDetails = React.lazy(() => import('./quotations/QuotationDetails'))

const PriceMulticalculoRoutes = [
  {
    path: '/multicalculo/:quotationIdentifier/status',
    Component: QuotationDetails,
    bgImage: BackgroundStatusCotacao,
  },
  {
    path: '/multicalculo/confirmacao',
    Component: QuotationDetails,
    bgImage: BackgroundStatusCotacao,
  },
  {
    path: '/multicalculo/fianca-locaticia',
    Component: LeaseBail,
    bgImage: BackgroundCotacao,
  },
  {
    path: '/multicalculo/judicial-deposito-recursal',
    Component: JudicialGuaranteeAppeal,
    bgImage: BackgroundCotacao,
  },
  {
    path: '/multicalculo/judicial-trabalhista',
    Component: JudicialGuaranteeLabor,
    bgImage: BackgroundCotacao,
  },
  {
    path: '/multicalculo/judicial-civel',
    Component: JudicialGuaranteeCivel,
    bgImage: BackgroundCotacao,
  },
  {
    path: '/multicalculo/garantia/licitante',
    Component: GuaranteeBID,
    bgImage: BackgroundCotacao,
  },
  {
    path: '/multicalculo/garantia/performance',
    Component: GuaranteePerformance,
    bgImage: BackgroundCotacao,
  },
  {
    path: '/multicalculo/upload',
    Component: UploadAndExtractFile,
    bgImage: BackgroundCotacao,
  },
  {
    path: '/multicalculo/processando',
    Component: ProcessingContract,
    bgImage: BackgroundCotacao,
  },
  {
    path: '/multicalculo/risco-engenharia',
    Component: EngineeringRisk,
    bgImage: BackgroundCotacao,
  },
  {
    path: '/multicalculo/garantia',
    Component: OtherGuarantee,
    bgImage: BackgroundCotacao,
  },
]

export default PriceMulticalculoRoutes
